export const REFRESH_DEBOUNCE_MS = 2000;
export const REFRESH_MAX_WAIT_MS = 5000;
export const REFRESH_JITTER_MS = 1500;
